<template>
  <div class="ownerManage">
    <div class="search_bar">
      <van-search v-model="listQuery.name" show-action placeholder="请输入货品进行搜索" @search="onSearch">
        <template slot="action">
          <div @click="onSearch">搜 索</div>
        </template>
      </van-search>
    </div>
    
    <div class="list">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="min-height:100%">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getList"
            >
            <div>
              <div class="content" @click="$router.push('/mine/bill/billDetail')">
                <div class="c-title">
                  <span>
                    <span>示例土豆</span>
                    <span class="spec">散装</span>
                  </span>
                  <span>2.1元/公斤</span>
                </div>
                <div class="c-spec">规格：6公斤/件</div>
              </div>
              <div class="content">
                <div class="c-title">
                  <span>
                    <span>示例土豆</span>
                    <span class="spec">散装</span>
                  </span>
                  <span>2.1元/公斤</span>
                </div>
                <div class="c-spec">规格：6公斤/件</div>
              </div>
            </div>
            
            </van-list>
        </van-pull-refresh>
    </div>
    <div class="add-btn">添加货品</div>
  </div>
</template>

<script>
import { owner_list } from "@/api/work/manage/owner";
export default {
  name: "ownerManage",
  data() {
    return {
      list: {},
      loading: true,
      finished: true,
      refreshing: false,
      listQuery: {
        page: 1,
        pageSize: "15",
        name: ""
      },

      
      use_type:1,
    };
  },
  created() {
    if(this.$route.query.use_type == 1){
      this.use_type = 1
    }else{
      this.use_type = 0
    }
    this.getList();
    
    
    this.$navigation.on('back', (to, from) => {
      if(to.route.name == 'manage_owner_ownerManage'){
          var listQuery= {
              page:1,
              pageSize :this.list.length,
              name:this.listQuery.name
          }
          owner_list(listQuery).then(res=>{
              if(res.code == 200 ){
                  this.list = res.data.list;
                  if(this.list.length == res.data.totalCount){
                      this.finished = true
                  }else{
                      this.loading = false
                      this.listQuery.pageSize = '15'
                  }
              }
          })
      }
    })
  },
  mounted() {},
  methods: {
    // 点击了搜索按钮
    onSearch(){
      this.listQuery.page = 1
      this.getList()
    },

    
    // 获取列表
    getList(){
      owner_list(this.listQuery).then(res=>{
        if(res.code == 200 ){
            if(this.listQuery.page == 1) this.list = []
            this.list = this.list.concat(res.data.list)
            if(this.list.length == res.data.totalCount || res.data.list.length == 0){
                this.finished = true;
            }else{
                this.loading = false
                this.listQuery.page++
            }
            this.refreshing = false;
        }
      })
    },
    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.listQuery.page = 1
      this.getList();
    },
    // 返回上一页
    backPage(item){
      this.$route.meta.backData = item
      this.$router.go(-1)
    }
  }
};
</script>

<style lang="less" scoped>
.ownerManage {
  .search_bar {
    position: sticky;
    top: 0.88rem;
    z-index: 2;
    box-shadow: 0 0 0.05rem 0.05rem #f1f1f1;
  }
  .list{
    padding: 0.3rem 0;
    .item{
      margin-bottom: 0.2rem;
    }
  }
  .content {
    background-color: #fff;
    padding: 0.32rem 0.2rem 0.23rem;
    .c-title{
      display: flex;
      justify-content: space-between;
      >span:first-child{
        font-size: 0.32rem;
        color: #333333;
        .spec{
          font-size: 0.24rem;
          color: #4B9C64;
          background: rgba(75,156,100,0.3);
          display: inline-block;
          text-align: center;
          width: 0.8rem;
          line-height: 0.36rem;
          border-radius: 0.18rem;
          margin-left: 0.2rem;
        }
      }
      >span:last-child{
        color: #F76900;  
      }
    }
    .c-spec{
      color: #666666;
      margin-top: 0.29rem;
    }
  }
  .content:not(:last-of-type){
    border-bottom: 0.01rem solid #E5E5E5;
  }
  .add-btn {
    width: 100%;
    line-height: 1rem;
    background-color: #31b158;
    color: #fff;
    font-size: 0.28rem;
    text-align: center;
    position: fixed;
    bottom: 0;
  }
}
</style>